export const THEME_PREFERENCES = ['AUTO', 'LIGHT', 'DARK'];

const AUTO_ONLY_PREFIXES = [
    '/login',
    '/registration',
    '/recovery',
    '/confirm-recovery',
    '/one-time-code',
    '/invite',
    '/questions',
    '/onboarding',
    '/last-step',
];

export function isAutoOnlyPath(pathname = '') {
    const path = String(pathname).split('?')[0].replace(/\/+$/, '') || '/';
    return AUTO_ONLY_PREFIXES.some((prefix) => path === prefix || path.startsWith(`${prefix}/`));
}

export function resolveThemeMode({ pathname, preference, systemDark }) {
    if (!isAutoOnlyPath(pathname) && preference === 'LIGHT') {
        return 'light';
    }
    if (!isAutoOnlyPath(pathname) && preference === 'DARK') {
        return 'dark';
    }
    return systemDark ? 'dark' : 'light';
}

export const THEME_ACCOUNT_CACHE_KEY = 'joinee.themePreference';

export function themeCacheKey(domain) {
    return `${THEME_ACCOUNT_CACHE_KEY}.${domain || 'unknown'}`;
}
